document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".placements-toggle-btn");

  buttons.forEach((btn) => {
    btn.addEventListener("click", function () {
      // Trouver le bloc .fl-row-content le plus proche
      const rowContent = btn.closest(".fl-row-content");
      if (!rowContent) return;

      // Trouver le bloc .placements-toggle à l'intérieur
      const toggleBlock = rowContent.querySelector(".placements-toggle");
      if (!toggleBlock) return;

      // Toggle de la classe expanded
      const wasExpanded = toggleBlock.classList.contains("expanded");
      const isExpanded = toggleBlock.classList.toggle("expanded");

      // Mettre à jour le texte du bouton
      btn.textContent = isExpanded ? "Voir moins" : "Voir plus";

      if (wasExpanded && !isExpanded) {
        toggleBlock.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  });
});
